import { AppUploadPage } from "fleet/view/application/upload";
import { connect } from "react-redux";
import { createPromiseApiAction } from "redux-store/api-sagas";
import { UPLOAD_APPLICATION } from "redux-store/applications";

function mapDispatchToProps(dispatch) {
  return {
    uploadApp: (file) => {
      return createPromiseApiAction(dispatch, UPLOAD_APPLICATION, [file]);
    },
  };
}

const ConnectedAppUpload = connect(null, mapDispatchToProps)(AppUploadPage);

export { ConnectedAppUpload };
